import { FlexBox } from '@airship-platform/jam-web/components';
import React from 'react';
import SignUpCard from './SignUpCard';
import SignUpForm from './SignUpForm';

const SignUpPage: React.FC = () => (
  <FlexBox height={'100%'} width={'100%'}>
    <SignUpCard />
    <SignUpForm />
  </FlexBox>
);

export default SignUpPage;
